import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import '../styles/ServicesPage.css';
import Breadcrumbs from '../components/Breadcrumbs';
import Lessons1 from '../assets/Services/InHome_9_TALL.png';

const LessonsPage = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className='service-page'>
      <Helmet>
        <title>Music Lessons Westchester NY | Guitar, Drums, Vocals</title>
        <meta
          name="description"
          content="Private in-home music lessons in Westchester County, including Mamaroneck and Larchmont. Learn guitar, drums, vocals, and more with expert instructors."
        />
      </Helmet>

      <Breadcrumbs />
      <h1>Lessons & Education</h1>

      <div className='wrapped-text-block'>
        <div style={{ maxWidth: '60vw' }}>
          <img
            src={Lessons1}
            alt='Instructor and Student In Home Lessons'
            className='float-image-left'
          />
        </div>
        <div style={{alignContent: 'center'}}>
          <p>
            Whether your child is just beginning to take an interest in music or you're dusting off your instrument for the first time in years, <strong>The Westchester Music Lab's</strong> <Link to='/services/lessons/in-home'>In-Home Private Lessons</Link> and <Link to='/services/lessons/studio'>In-Studio Lessons</Link> are personalized to meet each student's goals and interests. Our team's passionate tutors work with students of all ages, offering expert instruction across a wide range of instruments and genres, all within a supportive, personalized environment that nurtures creativity and growth.
          </p>

          <h2>What We Offer</h2>
          <ul>
            <li>One-on-one instruction for guitar, bass, drums, piano, vocals, and more.</li>
            <li>Tailored lesson plans for beginners, intermediate, and advanced musicians.</li>
            <li>Optional workshops for music theory, songwriting, and improvisation.</li>
          </ul>

          <p>
            We specialize in working with children, creating a fun and engaging learning environment that builds confidence and encourages creative exploration. Whether your child is picking up an instrument for the first time or already has some experience, our team of experienced instructors are ready to spark their love for music and help them thrive!
          </p>
        </div>
      </div>

      <Link to='/contact' className='btn btn-primary mt-3'>Get Started</Link>
    </div>
  );
};

export default LessonsPage;
